// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Prata', 'Prata Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_6fdd45"};